import { cn } from "@/utils/utils";
import useOffScrollBody from "@/lib/hooks/useOffScrollBody";
import { useState, useCallback, ReactNode, useEffect } from "react";

import ChevronLeftIcon from "@/components/icons/ChevronLeftIcon";

export interface DrawerProps {
  title?: ReactNode;
  open: boolean;
  onClose: () => void;
  children?: ReactNode;
  className?: string;
  classNameHeader?: string;
}

export default function Drawer({
  open,
  onClose,
  children,
  title,
  className,
  classNameHeader,
}: DrawerProps) {
  const [isOpen, setIsOpen] = useState(false);
  // const [isAnimating, setIsAnimating] = useState(false);

  const handleClose = useCallback(() => {
    setIsOpen(false);
    setTimeout(() => {
      onClose();
    }, 200);
  }, [onClose]);

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setIsOpen(open);
      }, 0);
    }
  }, [open]);

  useOffScrollBody(open);
  return (
    <>
      {open && (
        <div
          className={cn(
            `h-screen bg-white fixed inset-0 z-[5000] transition  ${
              isOpen ? "translate-x-[0px]" : "translate-x-[100%]  "
            }`,
            className
          )}
        >
          <div className="flex flex-col h-full">
            <div
              className={cn(
                "h-[40px] relative flex-shrink-0 px-4",
                classNameHeader
              )}
            >
              <button
                className="absolute left-4 top-0 bottom-0"
                onClick={handleClose}
              >
                <ChevronLeftIcon />
              </button>
              {title}
            </div>
            <div className="flex-1 h-full">{children}</div>
          </div>
        </div>
      )}
    </>
  );
}
